export default __webpack_public_path__ + "static/Harvester2-292b43e98c0a48ee4dca5aae22c9d15e.jpg";